import request from '@/utils/request';

// 获取我的会话列表
export const GetMyConversationList = (params) => {
    return request({
        url: '/api/chat/rooms',
        method: 'get',
        params
    });
};

// 发送消息
export const SendMessage = (data) => {
    return request({
        url: '/api/chat/message',
        method: 'post',
        data: {
            roomId: data.message_conversation,
            content_type: data.type || 'text',
            text_content: data.content,
            media_content: data.media_content
        }
    });
};

// 上传聊天消息图片
export const UploadMessageImage = (formData) => {
    return request({
        url: '/api/chat/message_image',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// 上传聊天消息文档
export const UploadMessageDocument = (formData) => {
    return request({
        url: '/api/chat/message_document',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// 获取我的消息列表
export const GetMyMessageList = (params) => {
    const { message_conversation, ...rest } = params;
    return request({
        url: '/api/chat/messages',
        method: 'get',
        params: {
            roomId: message_conversation,
            ...rest
        }
    });
};

// 查找或创建会话   
export const FindOrCreateConversation = (data) => {
    return request({
        url: '/api/message/findOrCreateConversation',
        method: 'post',
        data
    });
};

// 获取未读消息数
export const GetUnreadMessageCount = () => {
    return request({
        url: '/api/message/getUnreadMessageCount',
        method: 'get'
    });
};